<div class="pp">

  <!-- The product first: the panel itself, cut out of its window, on the stage. -->
  <div class="pp-stage">
    <header class="pp-wrap pp-intro">
      <div class="pp-intro-main">
        <span class="pp-platform">
          <!-- macos.webp is the macOS Terminal mark, which belongs to the terminal
               themes; the platform mark for a Mac app is this one. -->
          <img src="./assets/third-parties/logo/macos-apps.webp" alt="">
          macOS App
        </span>
        <h1 class="pp-name">
          <img src="./assets/product-lines/tools/macos-color-picker.png" alt="" class="pp-icon" width="72" height="72">
          <span>Color Picker</span>
        </h1>
        <p class="pp-pitch">Pick any color on your screen and read everything about it, right from your menu bar</p>
        <ul class="pp-facts" aria-label="At a glance">
          <li *ngFor="let f of facts">{{ f }}</li>
        </ul>
      </div>

      <div class="pp-act">
        <div class="pp-cta" [class.cp-cta-stack]="sellsHere">
          <!-- sold on the site too (2026-10-14): Add to cart with the price beside it (as in the themes box), then
               the Mac App Store; the Color Explorer button is gone (owner 2026-10-14) -->
          <ng-container *ngIf="sellsHere; else appStoreOnly">
            <!-- Add to cart and its price on one row, the Mac App Store on the row under it (owner 2026-10-14) -->
            <div class="cp-buy-row">
              <button type="button" class="codigrate-button" (click)="addToCart()"><p>Add to cart</p></button>
              <span class="cp-offer" *ngIf="priceLabel">
                <span class="cp-offer-amount">{{ priceLabel }}</span>
                <span class="cp-offer-note">One-time purchase</span>
              </span>
            </div>
            <a class="codigrate-button cp-btn-neutral" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall( $event )"><p>Install from the Mac App Store</p></a>
          </ng-container>
          <ng-template #appStoreOnly>
            <a class="codigrate-button" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall( $event )"><p>Install from the Mac App Store</p></a>
            <span class="codigrate-button cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
          </ng-template>
        </div>
      </div>
    </header>

    <div class="pp-wrap">
      <figure class="pp-shot" [class.pp-shot-panel]="hero.kind === 'panel'" [class.pp-shot-wide]="hero.kind === 'wide'">
        <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
      </figure>
    </div>
  </div>

  <div class="pp-wrap">

    <section class="pp-highlights" aria-label="Highlights">
      <div class="pp-highlight" *ngFor="let f of highlights">
        <h2>{{ f.title }}</h2>
        <p>{{ f.description }}</p>
      </div>
    </section>

    <section class="pp-section" *ngIf="screenshots.length">
      <h2 class="pp-section-title">Screenshots</h2>
      <div class="pp-gallery">
        <figure class="pp-figure" *ngFor="let s of screenshots">
          <button class="pp-shot" type="button" (click)="openLightbox( s )" [attr.aria-label]="'Enlarge ' + s.name">
            <img [src]="s.src" [alt]="s.alt" width="1600" height="1000" loading="lazy" decoding="async">
          </button>
          <figcaption>{{ s.name }}</figcaption>
        </figure>
      </div>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">What Else It Does</h2>
      <ul class="pp-list">
        <li *ngFor="let f of more">
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </li>
      </ul>
    </section>

    <!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss). The picture over a
         frosted backdrop and one pill under it: previous, the picture's name, next, close.
         The arrow keys page through the pictures and Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightbox.large" [alt]="lightbox.alt">
      </figure>
      <ng-container *ngIf="shots.length > 1">
        <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
        <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
      </ng-container>
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" *ngIf="shots.length > 1" (click)="stepLightbox( -1, $event )" aria-label="Previous screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
            <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" *ngIf="shots.length > 1" (click)="stepLightbox( 1, $event )" aria-label="Next screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <section class="cp-closing">
      <h2 class="cp-closing-title">Grab Your First Color</h2>
      <p class="cp-closing-text">Every value matches the Codigrate Color Explorer exactly, so what you copy is what you get</p>
      <div class="cp-closing-buy" *ngIf="sellsHere">
        <button type="button" class="codigrate-button cp-closing-btn" (click)="addToCart()"><p>Add to cart</p></button>
        <span class="cp-offer" *ngIf="priceLabel">
          <span class="cp-offer-amount">{{ priceLabel }}</span>
          <span class="cp-offer-note">One-time purchase</span>
        </span>
      </div>
      <a class="codigrate-button cp-closing-btn" [class.cp-btn-neutral]="sellsHere" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall( $event )"><p>Install from the Mac App Store</p></a>
      <!-- until the listing is public: the same Coming Soon as at the top (owner 2026-10-10: the foot of
           every app page is its store button, never another link) -->
      <span class="codigrate-button cp-closing-btn cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
    </section>

  </div>

</div>
